"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonTextColorVar = exports.getButtonTextColor = exports.buttonTextColorTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _mapButtonAppearance = require("./mapButtonAppearance");
const buttonTextColorTheme = (0, _sdsThemeInternal.themed)({
  primary: {
    //only lodestar-light
    enabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40),
    active: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40),
    disabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40)
  },
  secondary: {
    //only lodestar-light
    enabled: (0, _designTokensReact.color)("color--text--neutral--default", _designTokens.lodestarColors.neutralDark30),
    active: (0, _designTokensReact.color)("color--text--neutral--default", _designTokens.lodestarColors.neutralDark30),
    disabled: (0, _designTokensReact.color)("color--background--neutral--stronger", _designTokens.lodestarColors.neutralAccessible)
  },
  destructive: {
    //only lodestar-light
    enabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40),
    active: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40),
    disabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40)
  },
  "secondary-destructive": {
    //only lodestar-light
    enabled: _designTokens.lodestarColors.buttonDestructive,
    //#cc2e3b no token exists
    active: _designTokens.lodestarColors.buttonDestructive,
    //#cc2e3b no token exists
    disabled: _designTokens.lodestarColors.buttonDestructiveDisabled //no token exists
  },

  share: {
    //only lodestar-light
    enabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40),
    active: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40),
    disabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.lodestarColors.neutralLight40)
  },
  borderless: {
    enabled: _designTokens.lodestarColors.buttonPrimary,
    //#3576ba no token exists
    active: _designTokens.lodestarColors.buttonPrimary,
    //#3576ba no token exists
    disabled: (0, _designTokensReact.color)("color--text--neutral--weaker", _designTokens.lodestarColors.neutralDark10)
  },
  link: {
    enabled: {
      "lodestar-light": _designTokens.lodestarColors.ctaLink,
      //#0970be no token exists
      "ursa-light": (0, _designTokensReact.color)("color--text--primary--default", _designTokens.ursaColors.blue600)
    },
    active: {
      "lodestar-light": _designTokens.lodestarColors.focusDark,
      //#4c649d no token exists
      "ursa-light": _designTokens.ursaColors.linkDark //#2c6665 no token exists
    },

    disabled: (0, _designTokensReact.color)("color--text--neutral--weaker", _designTokens.lodestarColors.neutralDark10)
  },
  //Below are exclusive to ursa-light
  "primary-filled": {
    enabled: (0, _designTokensReact.color)("color--background--primary--weakest", _designTokens.ursaColors.blue50),
    active: (0, _designTokensReact.color)("color--background--primary--weakest", _designTokens.ursaColors.blue50),
    disabled: (0, _designTokensReact.color)("color--text--primary--weakest", _designTokens.ursaColors.blue25)
  },
  "primary-empty": {
    enabled: (0, _designTokensReact.color)("color--text--primary--default", _designTokens.ursaColors.blue600),
    active: (0, _designTokensReact.color)("color--text--primary--default", _designTokens.ursaColors.blue600),
    disabled: (0, _designTokensReact.color)("color--text--primary--weak", _designTokens.ursaColors.blue300)
  },
  "secondary-filled": {
    enabled: (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.ursaColors.neutral800),
    active: (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.ursaColors.neutral800),
    disabled: (0, _designTokensReact.color)("color--text--neutral--weak", _designTokens.ursaColors.neutral500)
  },
  "secondary-outlined": {
    enabled: (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.ursaColors.neutral800),
    active: (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.ursaColors.neutral800),
    disabled: (0, _designTokensReact.color)("color--text--neutral--weak", _designTokens.ursaColors.neutral500)
  },
  "secondary-empty": {
    enabled: (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.ursaColors.neutral800),
    active: (0, _designTokensReact.color)("color--text--neutral--strong", _designTokens.ursaColors.neutral800),
    disabled: (0, _designTokensReact.color)("color--text--neutral--weak", _designTokens.ursaColors.neutral500)
  },
  "canvas-filled": {
    enabled: (0, _designTokensReact.color)("color--text--slate--default", _designTokens.ursaColors.slate700),
    active: (0, _designTokensReact.color)("color--text--slate--default", _designTokens.ursaColors.slate700),
    disabled: (0, _designTokensReact.color)("color--text--slate--weakest", _designTokens.ursaColors.slate300)
  },
  "canvas-empty": {
    enabled: (0, _designTokensReact.color)("color--text--slate--default", _designTokens.ursaColors.slate700),
    active: (0, _designTokensReact.color)("color--text--slate--default", _designTokens.ursaColors.slate700),
    disabled: (0, _designTokensReact.color)("color--text--slate--weakest", _designTokens.ursaColors.slate300)
  },
  "destructive-filled": {
    enabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.ursaColors.neutral00),
    active: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.ursaColors.neutral00),
    disabled: (0, _designTokensReact.color)("color--text--neutral-inverse--strong", _designTokens.ursaColors.neutral00)
  },
  "destructive-empty": {
    enabled: (0, _designTokensReact.color)("color--text--error--weak", _designTokens.ursaColors.red600),
    active: (0, _designTokensReact.color)("color--text--error--weak", _designTokens.ursaColors.red600),
    disabled: (0, _designTokensReact.color)("color--background--destructive--default", _designTokens.ursaColors.red400)
  }
});

// For mapping state to the fontSettings color object above
exports.buttonTextColorTheme = buttonTextColorTheme;
const mapStateToFontSettingsString = _ref => {
  let {
    isDisabled = false,
    isActive = false
  } = _ref;
  // Disabled should always win
  if (isDisabled) {
    return "disabled";
  }
  // Active should win over enabled
  if (isActive) {
    return "active";
  }
  return "enabled";
};
const getButtonTextColor = _ref2 => {
  let {
    appearance,
    state,
    themeMode
  } = _ref2;
  const resolvedState = mapStateToFontSettingsString(state);
  return buttonTextColorTheme[(0, _mapButtonAppearance.mapButtonAppearance)(appearance, themeMode)][resolvedState](themeMode);
};

// For mapping state to the color object above
exports.getButtonTextColor = getButtonTextColor;
const mapStateToTextVar = _ref3 => {
  let {
    state
  } = _ref3;
  // Disabled should always win
  if (state.isDisabled) {
    return "--smar--sds--button--color--text--disabled";
  }
  // Active should win over hover
  if (state.isActive) {
    return "--smar--sds--button--color--text--active";
  }
  return "--smar--sds--button--color--text--rest";
};
const getButtonTextColorVar = props => {
  return `${mapStateToTextVar(props)}`;
};
exports.getButtonTextColorVar = getButtonTextColorVar;
//# sourceMappingURL=getButtonTextColor.js.map